import {emptyGuid, isNullOrUndefined} from "../../../../../Utilities/commonUtilities";

export const getLoanLibraryInventoryItemId = (loanLibraryInventoryItem: Record<string, any>, index: number) => {
    return !isNullOrUndefined(loanLibraryInventoryItem.loanLibraryInventoryItemId) && loanLibraryInventoryItem.loanLibraryInventoryItemId !== emptyGuid ? loanLibraryInventoryItem.loanLibraryInventoryItemId : `inventory-item-${index}`;

};